export const APP_CONFIG = {
  appName: '写作大冒险',
  aiName: '探险智多星',
} as const;
